module.exports = __webpack_public_path__ + "img/arpa-cerimonia.96bf7d4c.jpg";